<section>
  <h1 class="center">
    Bordereaux
  </h1>
  <h2 class="subtitle">
    Ici vous pouvez télécharger les bordereaux clients des {{delay}} derniers jours
  </h2>
  <div class="flex justify-center">
    <div class="clamp-bordereaux">
      <div *ngIf="!bordereaux" class="flex justify-center">
        <mat-spinner></mat-spinner>
      </div>
      <p *ngIf="bordereaux && bordereaux.length == 0" class="flex justify-center">Aucun bordereaux disponibles</p>
      <table class="styled-table" *ngIf="bordereaux && bordereaux.length > 0">
        <thead>
          <tr>
            <th>Date de l'export</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of bordereaux">
            <td class="relative">
              {{ data.date | date: 'EEEE': 'fr' | titlecase }} - {{ data.date | date: 'dd/MM/yyyy': 'fr'}}
              <mat-icon (click)="export(data)" matTooltip="Télécharger" class="absolute right-2 icon-click"
                [ngClass]="download ? 'disabled' : ''">
                picture_as_pdf
              </mat-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>